<template>
  <router-link :to="{name: 'BusinessDetail', params: { business: bizSlug}}">
    <div class="featured__box padding-left-13 padding-right-13">
      <img :src="`/static/img/pages/home/featured/${imgName}/${imageName}.${imgFormat}`" :style="{'max-width': maxWidth, 'max-height': maxHeight}"/>
    </div>
  </router-link>
</template>
<script>

import {misc} from '@/mixins'

export default {
  name: 'FeaturedBox',
  mixins: [misc],
  props: {
    imgName: {
      type: String,
      required: true
    },
    imgFormat: {
      type: String,
      required: true
    },
    bizSlug: {
      type: String,
      required: true
    },
    dimensions: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data () {
    return {}
  },
  computed: {
    imageName () {
      if (this.bizSlug === 'miway') {
        return `${this.imgName}_${this.deviceType}`
      }
      return this.imgName
    },
    maxWidth () {
      return this.dimensions ? this.dimensions[this.deviceType][0] + 'px' : ''
    },
    maxHeight () {
      if (this.dimensions && this.dimensions.length > 1) {
        return this.dimensions[this.deviceType][1] + 'px'
      }
      return ''
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

a {
  margin-right: 20px;
  margin-bottom: 15px;

  @include tablet {
    margin-right: 9px;
    margin-bottom: 9px;
  }

  @include mobile {
    margin-right: 5px;
    margin-bottom: 5px;
  }
}

.featured__box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 170px;
  height: 130px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;

  @include not-desktop {
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
  }

  @include tablet {
    width: 177px;
    height: 143px;
  }

  @include mobile {
    width: 100px;
    height: 80px;

    img {
      max-width: 80px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/FeaturedBox.vue